// Set of top level Resource categories
const RESOURCE_TERM_PRODUCT_INTERESTS = "Product Interest";
const RESOURCE_TERM_INDUSTRIES = "Industries";
const RESOURCE_TERM_RESOURCE_TYPE = "Resource Type";
const RESOURCE_TERM_TOPIC = "Topic";

const RESOURCE_CONTENT_TYPE_ID = "resource";
const RESOURCE_TERM_CONTENT_TYPE_ID = "resourceTerm";

const RESOURCE_NO_RESULTS_TEXT = "resource.no-results-text";
const RESOURCE_RESET_FILTERS_TEXT = "resource.clear-filter";
const RESOURCE_RESET_ALL_FILTERS = "resource.clear-all-filters";
const RESOURCE_RESULTS_ERROR = "resource.validation-no-results-text";
const RESOURCE_KEYWORD_PLACEHOLDER = "resource.search-text";
const RESOURCE_GATED_MESSAGE = "resource.gated-message";
const RESOURCE_GATED_CTA_TEXT = "resource.gated-cta-text";
const RESOURCE_GATED_ACCESS_TEXT = "resource.gated-access-text";
const RESOURCE_GATED_FORM_EXPIRY = 60 * 1000 * 30; // 30 minutes
const RESOURCE_PATHNAME = "resource-library";
const RESOURCE_BUTTON_TYPE = "Green Link";
const RESOURCE_BUTTON_TEXT = "resource.button-text";
const RESOURCE_GATED_CONTENT_RENDERING_NAME = "Gated Content";
const RESOURCE_GATED_LOADING_TEXT = "resource.gated-loading-text";
const RESOURCE_GATED_REDIRECTING_TEXT = "resource.gated-redirection-text";
const RESOURCE_GATED_SUCCESS_PAGE_PATHNAME = "thank-you";
const RESOURCE_PAGE_SIZE = 9;
const RESOURCE_BUTTON_DEFAULT_READ_MORE_TEXT = "Read More"; // This will be loaded as a fallback text only when the microcopy value is not available;

/**
 * Mapping of category types against query params for Resource
 */
const resourceCategoryFieldMapping = {
    [RESOURCE_TERM_RESOURCE_TYPE]: "resourceType",
    [RESOURCE_TERM_PRODUCT_INTERESTS]: "productInterest",
    [RESOURCE_TERM_TOPIC]: "topic",
    [RESOURCE_TERM_INDUSTRIES]: "industry",
};

export {
    RESOURCE_TERM_PRODUCT_INTERESTS,
    RESOURCE_TERM_INDUSTRIES,
    RESOURCE_TERM_RESOURCE_TYPE,
    RESOURCE_TERM_TOPIC,
    RESOURCE_CONTENT_TYPE_ID,
    RESOURCE_TERM_CONTENT_TYPE_ID,
    resourceCategoryFieldMapping,
    RESOURCE_NO_RESULTS_TEXT,
    RESOURCE_RESET_FILTERS_TEXT,
    RESOURCE_RESET_ALL_FILTERS,
    RESOURCE_RESULTS_ERROR,
    RESOURCE_KEYWORD_PLACEHOLDER,
    RESOURCE_GATED_MESSAGE,
    RESOURCE_GATED_FORM_EXPIRY,
    RESOURCE_PATHNAME,
    RESOURCE_GATED_CTA_TEXT,
    RESOURCE_GATED_ACCESS_TEXT,
    RESOURCE_GATED_CONTENT_RENDERING_NAME,
    RESOURCE_GATED_LOADING_TEXT,
    RESOURCE_GATED_SUCCESS_PAGE_PATHNAME,
    RESOURCE_GATED_REDIRECTING_TEXT,
    RESOURCE_PAGE_SIZE,
    RESOURCE_BUTTON_DEFAULT_READ_MORE_TEXT,
    RESOURCE_BUTTON_TEXT,
    RESOURCE_BUTTON_TYPE,
};
